import { Component, ElementRef, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { LocationLanguageService } from '@app/Modules/Shared/Services/location-language.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { waysToContactDropdown } from "@app/conf/dataConfigurations";
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { LanguageSelectionService } from '@app/Modules/Shared/Services/language-selection.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';



@Component({
  selector: 'app-sensitive-data',
  templateUrl: './sensitive-data.component.html',
  styleUrls: ['./sensitive-data.component.scss']
})
export class SensitiveDataComponent implements OnInit, OnDestroy {

  @ViewChild('commentsText') commentsText: ElementRef;
  searchForm: FormGroup;
  isLoggedIn: boolean = false;
  selectedCountry: string;
  selectedSalesOrg: string;
  defaultRegion: string;
  templateConfig: any = {
    "region": {
      display: true,
      order: "1"
    },
    "country": {
      display: true,
      order: "2"
    },
    "salesOrg": {
      display: true,
      order: "3"
    },
    "language": {
      display: true,
      order: "4"
    }
  };
  regions: Array<any>;
  countries: Array<any>;
  languages: Array<any>;
  locationLanguageSelectorForm: FormGroup;
  selectedRegion: string;
  _selectedLocationLanguage: any;
  selectedLanguage: any;
  dataLoaded: boolean;
  selectedCountryLabel: any;
  selectedCountryValue: any;
  userProfileData: any;
  oktaProfile: any;
  waysToContactDropdown: any;
  region: string;
  language: string;
  legalStatement: string;
  privacyPolicy: string;
  isGlobalUser: boolean = false;
  username: string;
  globalUserName: string;
  selectLabel: string;
  regionNA: any;
  CPRAdoNotSell: boolean;
  CPRALimit: boolean;
  userId: string;
  errorOnCPRA: boolean = false;
  get selectedLocationLanguage(): any {
    return this._selectedLocationLanguage;
  }
  set selectedLocationLanguage(value: any) {
    this._selectedLocationLanguage = value;
    // this.setDefaultLocation();
  }


  constructor(
    private _appService: AppService,
    private httpService: HttpService,
    private locationLanguageService: LocationLanguageService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private _globalAppService: GlobalAppService,
    private languageService: LanguageSelectionService,
    private messageService: MessageService,
    private router: Router) { }

  ngOnDestroy(): void {
    
  }

  ngOnInit(){
    
    this.isGlobalUser = this._appService.isGlobalUser;
    this.waysToContactDropdown = waysToContactDropdown;
    this.region = this._globalAppService.getDefaultRegionString();
   
    if(this.region == "NA"){
      this.regionNA = true;
    }else{
      this.regionNA= false;
    }
    this.language = this._globalAppService.getDefaultLanguageString() || 'en-US';
    this._globalAppService.getDefaultRegion().subscribe(region => {
      if (region) {
        this.region = region;
        this._globalAppService.getDefaultLanguage().subscribe(lang => {
          if (region && lang) {
            this.language = lang;
            this.translateService.setDefaultLang(this.region + '/' + this.languageService.getLanguageCode(this.region,this.language).toLowerCase());
          }
        })
      }
    });
    if (this._appService.AvailableOKtaProfile) {
      this.oktaProfile = this._appService.AvailableOKtaProfile;
      this.isLoggedIn = true;
      if (!this.isLoggedIn) {
        this.loadLocationLanguageData();
      }
      else {
        this.httpService.getUserProfile(this._appService.getuserId(false)).subscribe((data) => {
          if ((data && data['defaultCustomerInfo'] && data['defaultCustomerInfo'].length)) {
            this.userProfileData = data["defaultCustomerInfo"][0];
          }
        });
        this.translateService.setDefaultLang(this.region + '/' + this.languageService.getLanguageCode(this.region,this.language).toLowerCase());
      }
    }
    else {
      this.loadLocationLanguageData(false, true);
    }

    this.languageService.getlanguage().subscribe(language => {
      this.getLanguageChange(language);
    });
    let selectedCountryLang =  {country: 'US', language: 'en-US', salesOrg: 0}
    let currentLanguage = this._globalAppService.getDefaultLanguageString() || 'en-US';
    if (selectedCountryLang && selectedCountryLang.language) {
      currentLanguage = selectedCountryLang.language;
    }
    // this.getLanguageChange(currentLanguage);
    this.getLanguageChange(currentLanguage);
    this.populateUserDetails();

    // debugger
  }

  getGlobalUserDetails(username) {
    let userId = this._appService.getuserId(true);
    this.globalUserName = username + "( " + userId + " )";
  }

  getLanguageChange(language) {
    if (language)
      this.translateService.use(this.region + '/' + this.languageService.getLanguageCode(this.region,language).toLowerCase());
      // this.translateService.get(['dataConfigData.waysToContactDropdown.select']).subscribe(translations =>{
      //   this.selectLabel = translations['dataConfigData.waysToContactDropdown.select'];
      // })
  }

  loadLocationLanguageData(isLoadingOnDrownDownChanges = false, isOnLoad = false) {
    let languageFromParams = this.activatedRoute.snapshot.queryParamMap.get('language');
    if(languageFromParams && isOnLoad){
      this.httpService.getLocationsWithDefaultLanguage(languageFromParams).subscribe((locations) => {
        if (locations && locations.response && locations.response.length) {
          this.locationLanguageService.setLocationLanguageData(locations.response);
          this.populateLocations(isLoadingOnDrownDownChanges);
          this.initPage();
          this.loadContactContent(this.selectedLocationLanguage);
        }
      });
    } else {
      this.httpService.getLocations().subscribe((locations) => {
        if (locations && locations.response && locations.response.length) {
          this.locationLanguageService.setLocationLanguageData(locations.response);
          this.populateLocations(isLoadingOnDrownDownChanges);
          this.initPage();
          this.loadContactContent(this.selectedLocationLanguage);
        }
      });
    }    
  }

  populateLocations(isLoadingOnDrownDownChanges = false) {
    if(!isLoadingOnDrownDownChanges){
      this.setDefaultLocation();
    }
    this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
    this.regions = this.locationLanguageService.getAllRegions();
    this.regions = this.regions && this.regions.length ? this.regions.sort() : null;
    if (!this.selectedLocationLanguage || !this.selectedLocationLanguage.region) {
      this.selectedLocationLanguage = {
        region: this.regions[0].value
      };
    }
    this.countries = this.locationLanguageService.getCountriesForRegion(this.selectedLocationLanguage.region);
    this.countries = this.countries && this.countries.length ? this.countries.sort() : null;
    if (!this.selectedLocationLanguage || !this.selectedLocationLanguage.country) {
      this.selectedLocationLanguage = {
        region: this.regions[0].value,
        country: this.countries[0].value
      };
      this.selectedCountryLabel = this.countries.find(c => {
        return c.value === this.selectedLocationLanguage.country;
      }).label;
      this.selectedCountryValue = this.countries.find(c => {
        return c.value === this.selectedLocationLanguage.country;
      }).value;
    }
    this.languages = this.locationLanguageService.getLanguagesForCountry(this.selectedLocationLanguage.region, this.selectedLocationLanguage.country);
    this.languages = this.languages && this.languages.length ? this.languages.sort() : null;
    if (!this.selectedLocationLanguage || !this.selectedLocationLanguage.language) {
      this.selectedLocationLanguage = {
        region: this.regions[0].value,
        country: this.countries[0].value,
        language: this.languages[0].value
      };
    }
    this.dataLoaded = true;
  }

  initFormGroup() {
    if (this.selectedRegion === 'APAC') {
      this.locationLanguageSelectorForm = this.fb.group({
        region: [''],
        country: [''],
        salesOrg: [''],
        language: ['']
      })
    }
    else {
      this.locationLanguageSelectorForm = this.fb.group({
        region: [''],
        country: [''],
        language: ['']
      })
    }
  }


  async loadcomponentConfig() {
    let { locationLanguageSelector } = await this._appService.dynamicImport(this.selectedLocationLanguage.region);
    Object.assign(this.templateConfig, locationLanguageSelector);
  }

  presetSelectLocationValues() {
    let inputParameter = { 'value': this.defaultRegion };
    this.locationLanguageSelectorForm.get('region').setValue(this.defaultRegion);
    // this.onRegionChange(inputParameter)
  }

  // formChangesListener() {
  //   let me = this;
  //   this.locationLanguageSelectorForm.valueChanges.subscribe(changes => {
  //     me.loadContactContent(changes);
  //   })


  // }

  initPage() {
    this.loadcomponentConfig();
    this.initFormGroup();
    this.autoSelectLocationValues();
    if (this.defaultRegion) {
      this.presetSelectLocationValues();
    }
  }

  setDefaultLocation() {
    // Check for query params storage first ir not available read from browser storage
    if (this.activatedRoute.snapshot.queryParams && Object.keys(this.activatedRoute.snapshot.queryParams).length) {
      this.readQueryParams();
    }
    else if (typeof (Storage) !== 'undefined' && localStorage.getItem("KCC.CP.selectedLocationLanguage") && localStorage.getItem("KCC.CP.selectedLocationLanguage") !== 'undefined') {
      this.readLocationFromLocalStorage();
    }
    else {
      this.selectedLocationLanguage = {
        region: "LAO",
        country: "AR",
        language: 'es-AR'
      }
    }
    this.translateService.setDefaultLang(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region,this.selectedLocationLanguage.language).toLowerCase());
  }

  autoSelectLocationValues() {
    this.selectedRegion = this.locationLanguageService.doesRegionExists(this.selectedLocationLanguage.region, this.regions) ? this.selectedLocationLanguage.region : this.regions[0].value;
    this.selectedCountry = this.locationLanguageService.doesCountryExists(this.selectedLocationLanguage.country, this.countries) ? this.selectedLocationLanguage.country : this.countries[0].value;
    this.selectedLanguage = this.locationLanguageService.doesLangaugeExists(this.selectedLocationLanguage.language, this.languages) ? this.selectedLocationLanguage.language : this.languages[0].value;
    this.locationLanguageSelectorForm.get('region').setValue(this.selectedRegion);
    this.locationLanguageSelectorForm.get('country').setValue(this.selectedCountry);
    this.locationLanguageSelectorForm.get('language').setValue(this.selectedLanguage);
  }

  readLocationFromLocalStorage() {
    let parsedPreference = JSON.parse(localStorage.getItem("KCC.CP.selectedLocationLanguage"));
    this.selectedLocationLanguage = {
      region: parsedPreference.region,
      country: parsedPreference.country,
      language: parsedPreference.language
    }
  }

  readQueryParams() {
    let languageFromParams = this.activatedRoute.snapshot.queryParamMap.get('language');
    const regionFromParams = this.activatedRoute.snapshot.queryParamMap.get('region');
    if(languageFromParams)
    {
      languageFromParams = languageFromParams.substring(0, 3).toLowerCase() + languageFromParams.substring(3).toUpperCase();
      this.selectedLocationLanguage =
      {
        region: this.activatedRoute.snapshot.queryParamMap.get('region').toUpperCase(),
        country: this.activatedRoute.snapshot.queryParamMap.get('country').toUpperCase(),
        language: languageFromParams
      }
    }
    else if(regionFromParams)
    {
      this.onRegionChange({value:regionFromParams});
    }
    
    
  }

  onRegionChange(event) {
    let region = event.value;
    /** On region Change make the API call With Default en-US languagecode to get the Region country and location data */
    this.httpService.getLocationsWithDefaultLanguage("en-US").subscribe((locations) => {
      if (locations && locations.response && locations.response.length) {
        this.locationLanguageService.setLocationLanguageData(locations.response);
        this.countries = this.locationLanguageService.getCountriesForRegion(region);
        this.languages = this.locationLanguageService.getLanguagesForCountry(region, this.countries[0].value);
        this.selectedLocationLanguage = {
          region: region,
          country: (region == 'NA' ? this.countries[1].value : this.countries[0].value),
          language: 'en-' + (region == 'NA' ? this.countries[1].value : this.countries[0].value)
        }

        this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
        this.loadContactContent(this.selectedLocationLanguage);
        this.translateService.use(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region,this.selectedLocationLanguage.language).toLowerCase());
        this._globalAppService.setDefaultLanguage(this.selectedLocationLanguage.language);
        this.loadLocationLanguageData(true);
      }
    });
  }

  onCountryChange(event) {
    let country: string = event.value;
    this.languages = this.locationLanguageService.getLanguagesForCountry(this.selectedLocationLanguage.region, country);
    this.selectedLocationLanguage = {
      region: this.selectedLocationLanguage.region,
      country: country,
      language: 'en-' + country //this.languages[0].value
    }
    this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
    this.loadContactContent(this.selectedLocationLanguage);
    this.translateService.use(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region,this.selectedLocationLanguage.language).toLowerCase());
    this._globalAppService.setDefaultLanguage(this.selectedLocationLanguage.language);
    this.loadLocationLanguageData(true);
  }

  onLanguageChange(event) {
    let language: string = event.value;
    this.selectedLocationLanguage = {
      region: this.selectedLocationLanguage.region,
      country: this.selectedLocationLanguage.country,
      language: language
    }
    this.translateService.get(['dataConfigData.waysToContactDropdown.select']).subscribe(translations =>{
      this.selectLabel = translations['dataConfigData.waysToContactDropdown.select'];
    })
    this.loadContactContent(this.selectedLocationLanguage);
    this.translateService.use(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region,this.selectedLocationLanguage.language).toLowerCase());
    this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
    this._globalAppService.setDefaultLanguage(this.selectedLocationLanguage.language);
    this.loadLocationLanguageData(true);
  }

  loadContactContent(selectedLocationLanguage: any) {
    this._appService.setLoadingStatus(true);
    if (this.countries && this.countries.length)
      this.selectedCountryLabel = this.countries.find(c => {
        return c.value === selectedLocationLanguage.country;
      }).label;
      this.selectedCountryValue = this.countries.find(c => {
        return c.value === selectedLocationLanguage.country;
      }).value;
    let request: any = {
      "regionId": selectedLocationLanguage.region,
      "countryId": selectedLocationLanguage.country,
      "languageCode": selectedLocationLanguage.language,
      "contentTypes": [
        {
          "contentType": selectedLocationLanguage.region == 'EMEA' ? "Contacts" : 'RegisterContact'
        }
      ]
    }
    let footerRequest: any = {
      "regionId": selectedLocationLanguage.region,
      "countryId": selectedLocationLanguage.country,
      "languageCode": selectedLocationLanguage.language,
      "contentTypes": [
        {
          "contentType": "GlobalFooter"
        }
      ]
    }
    this.httpService.getKCPContent(footerRequest).subscribe(data => {
      if (data && data.result && data.result.length > 0) {
        let dataResult = JSON.parse(data.result[0].data);
        this.privacyPolicy = dataResult.privacypolicy;
        this.legalStatement = dataResult.legalstatement;
      }
    });
  }

     /*
      #85393 Save the selection success message
      Changed by Laura Szmulewicz L55766
      Change date: 11/18/2022
    */
  populateUserDetails() {
    this.httpService.getUserDetails().subscribe(userDetails => {
      this._globalAppService.setUserDetails(userDetails.result);
      this.userId = userDetails.result.userId;
      this.CPRAdoNotSell = userDetails.result.cpraDonotSellPI || false;
      this.CPRALimit = userDetails.result.cpraLimitUsePI || false;
      let CPRAFlag = this.CPRAdoNotSell || this.CPRALimit;
      localStorage.setItem('cpra-restriction-set',CPRAFlag?'true':'false');
    });
       
  }

  saveUserDetails() {
     
      let doNotSellCheckbox = document.getElementById('do-not-sell') as HTMLInputElement;
      let limitCheckbox = document.getElementById('limit') as HTMLInputElement;
      this.CPRAdoNotSell = doNotSellCheckbox.checked;
      this.CPRALimit = limitCheckbox.checked;
      let objectToSend = {
        userId: this.userId,
        cpraDonotSellPI: this.CPRAdoNotSell,
        cpraLimitUsePI: this.CPRALimit
      }

      this.httpService.saveDetailsCPRA(objectToSend).subscribe((respone)=> {
        if (respone && respone.respone.isSaved) {
          
          //-- story #90174, to update the local storage after saving the details
          let CPRAFlag = this.CPRAdoNotSell || this.CPRALimit;
          localStorage.setItem('cpra-restriction-set',CPRAFlag?'true':'false');
          //--
          
          /*
          #87925 Save the selection success message
          Changed by Laura Szmulewicz L55766
          Change date: 11/18/2022
          */
          this.messageService.clear();
          this.messageService.add({ key: 'sensitiveDataSucess', severity: 'success', summary: 'sensitiveData.messageText.changesSaved.successHeader', detail: 'sensitiveData.messageText.changesSaved.sucessText', sticky: true });         
        } else if (respone && respone.status != "OK") {
          this.messageService.clear();
          this.messageService.add({ key: 'sensitiveDataError', severity: 'error', summary: 'sensitiveData.messageText.error.errorHeader', detail: 'sensitiveData.messageText.error.errorText', sticky: true });
        };
        
      })
  }  
}
